import { Component, type ErrorInfo, type ReactNode } from 'react';
import { captureException } from '../lib/sentry.js';
import { Icon } from '@jaluzi/ui';

interface State { error: Error | null }

export class ErrorBoundary extends Component<{ children: ReactNode }, State> {
  override state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  override componentDidCatch(error: Error, info: ErrorInfo): void {
    // eslint-disable-next-line no-console
    console.error('[ErrorBoundary]', error, info.componentStack);
    // No-op если Sentry DSN не задан
    captureException(error, { componentStack: info.componentStack });
  }

  reload = () => {
    this.setState({ error: null });
    window.location.reload();
  };

  override render() {
    if (this.state.error) {
      return (
        <div style={{
          minHeight: '100dvh', display: 'grid', placeItems: 'center',
          background: 'var(--bg-soft)', padding: 24,
        }}>
          <div style={{ maxWidth: 380, textAlign: 'center' }}>
            <div style={{ marginBottom: 12 }}><Icon name="triangle-alert" size={36} /></div>
            <div style={{
              fontFamily: 'Newsreader, serif', fontSize: 22, fontStyle: 'italic',
              marginBottom: 8,
            }}>
              Что-то сломалось
            </div>
            <div style={{ fontSize: 13, color: 'var(--text-muted)', marginBottom: 18 }}>
              {this.state.error.message}
            </div>
            <button onClick={this.reload} className="jb-btn jb-btn--full">
              Перезагрузить
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
